import React from "react";
import { AuthContextProvider } from "./src/context/AuthContext";

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
  return <AuthContextProvider {...props}>{element}</AuthContextProvider>;
};
